/* ============================================================
   IMAGE FASHIONWAY — Theme JavaScript
   Vanilla JS, no framework dependencies
   ============================================================ */

/* ---- SVG icons (matches design) ---- */
const IF_ICONS = {
  search: "M21 21l-4.3-4.3M11 19a8 8 0 110-16 8 8 0 010 16z",
  user: "M20 21a8 8 0 10-16 0M12 11a4 4 0 100-8 4 4 0 000 8z",
  bag: "M6 8h12l1 12H5L6 8zM9 8V6a3 3 0 016 0v2",
  menu: "M3 6h18M3 12h18M3 18h18",
  x: "M6 6l12 12M18 6L6 18",
  chevR: "M9 6l6 6-6 6",
  chevL: "M15 6l-6 6 6 6",
  chevD: "M6 9l6 6 6-6",
  arrowR: "M5 12h14M13 6l6 6-6 6",
  truck: "M3 7h11v8H3zM14 10h4l3 3v2h-7zM7 19a2 2 0 100-4 2 2 0 000 4zM18 19a2 2 0 100-4 2 2 0 000 4z",
  shield: "M12 3l8 3v6c0 4.5-3.2 7.7-8 9-4.8-1.3-8-4.5-8-9V6l8-3z",
  refresh: "M3 12a9 9 0 0115.5-6.3M21 12a9 9 0 01-15.5 6.3M18 4v4h-4M6 20v-4h4",
  cod: "M3 7h18v10H3zM3 11h18M7 15h3",
  spark: "M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6z",
  check: "M5 12l5 5L20 6",
  chat: "M21 15a4 4 0 01-4 4H8l-5 3V7a4 4 0 014-4h10a4 4 0 014 4v8z",
  wa: "M12 2a10 10 0 00-8.5 15.2L2 22l4.9-1.4A10 10 0 1012 2zm0 2a8 8 0 11-4.3 14.7l-.3-.2-2.6.7.7-2.5-.2-.3A8 8 0 0112 4z",
  send: "M4 12l16-7-7 16-2-7-7-2z",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  eye: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 100-6 3 3 0 000 6z",
  star: "M12 3l2.5 5.6 6.1.6-4.6 4 1.4 6-5.4-3.2L6.6 19l1.4-6L3.4 9.2l6.1-.6L12 3z",
  flame: "M12 22c4 0 7-2.7 7-7 0-3-1.5-4.5-3-7-.5 2-2 3-2 3s.5-4-3-8c0 4-4 6-4 11 0 4.3 3 8 5 8z",
  insta: "M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm10 3.5a1 1 0 100 2 1 1 0 000-2zM12 7a5 5 0 100 10 5 5 0 000-10z",
  fb: "M14 9h3V5h-3a4 4 0 00-4 4v2H7v4h3v6h4v-6h3l1-4h-4V9a1 1 0 011-1z",
  yt: "M22 8.2a3 3 0 00-2-2C18 5.7 12 5.7 12 5.7s-6 0-8 .5a3 3 0 00-2 2C1.7 10 1.7 12 1.7 12s0 2 .3 3.8a3 3 0 002 2c2 .5 8 .5 8 .5s6 0 8-.5a3 3 0 002-2c.3-1.8.3-3.8.3-3.8s0-2-.3-3.8zM10 15V9l5 3-5 3z",
  pin: "M12 22s7-6 7-12a7 7 0 10-14 0c0 6 7 12 7 12zM12 12a3 3 0 100-6 3 3 0 000 6z",
  tag: "M3 12V3h9l9 9-9 9-9-9zM8 8h.01",
  crown: "M3 18l2-10 5 5 2-7 2 7 5-5 2 10H3z",
  gift: "M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7S11 2 8 2 5 5 7 7M12 7s1-5 4-5 1 5-1 5",
  clock: "M12 21a9 9 0 100-18 9 9 0 000 18zM12 7v5l3 2",
  verified: "M9 12l2 2 4-4M12 3l2.3 1.5 2.7-.3 1 2.6 2.3 1.5-.8 2.6.8 2.6-2.3 1.5-1 2.6-2.7-.3L12 21l-2.3-1.5-2.7.3-1-2.6L3.7 16l.8-2.6-.8-2.6 2.3-1.5 1-2.6 2.7.3L12 3z",
};

function icon(d, size = 20, sw = 1.6, fill = "none") {
  const stroke = fill === "none" ? "currentColor" : "none";
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="${fill}" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;
}

function stars(n = 5, size = 13) {
  return Array.from({ length: 5 }, (_, i) => {
    const filled = i < Math.round(n);
    return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="${filled ? 'var(--gold)' : 'none'}" stroke="var(--gold)" stroke-width="1.4"><path d="${IF_ICONS.star}"/></svg>`;
  }).join('');
}

const inr = n => '₹' + Number(n).toLocaleString('en-IN');

// Escapes text before it's interpolated into an innerHTML template — required
// anywhere a value isn't fully merchant/Shopify-controlled (e.g. raw customer
// input like the predictive search query), so it can't be used to inject HTML.
function escapeHtml(str) {
  return String(str ?? '').replace(/[&<>"']/g, ch => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[ch]));
}

/* ============================================================
   STOCK CACHE — avoids hammering /products/handle.js on every
   qty + click. Each product handle is cached for 30 s; after
   that the next click fetches fresh data automatically.
   ============================================================ */
const _stockCache = {};

// Overrides learned from Shopify server enforcement (e.g. silent quantity cap
// in /cart/add.js or /cart/change.js). When the storefront API returns
// inventory_quantity:0 for a multi-location product but the server caps at N,
// we record N here so the + button can enforce the real limit without needing
// the API to return accurate data.
const _knownStock = {}; // { handle: { variantId: { qty, management, policy } } }

function setKnownStock(handle, variantId, qty, management = 'shopify', policy = 'deny') {
  if (!handle || !variantId) return;
  if (!_knownStock[handle]) _knownStock[handle] = {};
  _knownStock[handle][String(variantId)] = { qty, management, policy };
}

async function fetchLiveStock(handle, variantId) {
  const now = Date.now();
  const TTL = 30_000;
  const cached = _stockCache[handle];
  let pData;
  if (cached && now - cached.ts < TTL) {
    pData = cached.data;
  } else {
    const res = await fetch(`/products/${handle}.js`, { cache: 'no-store' });
    pData = await res.json();
    _stockCache[handle] = { data: pData, ts: now };
  }
  const v = pData.variants.find(v => String(v.id) === String(variantId));
  if (!v) return Infinity;                                // not found — fail open

  // known = the Liquid-rendered snapshot taken at page load (sums all locations,
  // more reliable than the storefront API for multi-location stores where
  // /products/handle.js can return available:false while admin shows stock).
  const known = _knownStock[handle]?.[String(variantId)];
  const management = known ? known.management : v.inventory_management;
  const policy = known ? known.policy : v.inventory_policy;
  if (!management) return Infinity;           // not tracked — no limit
  if (policy === 'continue') return Infinity; // backorders allowed

  // known.qty can go STALE mid-visit (someone else buys the last few units while
  // this customer is browsing), so it must never be trusted forever. The live
  // storefront number is refreshed at least every 30s (or immediately after
  // invalidateStockCache). Whichever of the two is SMALLER wins — that's always
  // the safe direction, since a customer can only oversell by the number being
  // too generous, never by it being too strict.
  const liveQty = (v.available !== false && typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0)
    ? v.inventory_quantity : undefined;
  const knownQty = (known && known.qty > 0) ? known.qty : undefined;

  if (liveQty !== undefined && knownQty !== undefined) return Math.min(liveQty, knownQty);
  if (liveQty !== undefined) return liveQty;
  if (knownQty !== undefined) return knownQty;
  if (v.available === false) return 0;                    // Shopify says OOS
  return Infinity;
}

function invalidateStockCache(handle) {
  if (handle) delete _stockCache[handle];
}

// Sums quantity across all cart lines for a variant — a discount app can split
// one variant across multiple line items (different price tiers), so a plain
// .find() undercounts what's actually in the cart.
function cartQtyForVariant(items, variantId) {
  return (items || []).filter(i => String(i.variant_id) === String(variantId))
    .reduce((sum, i) => sum + i.quantity, 0);
}

/* ============================================================
   SCROLL REVEAL
   ============================================================ */
function initReveal() {
  const els = document.querySelectorAll('.reveal:not(.in)');
  if (!('IntersectionObserver' in window)) {
    els.forEach(e => e.classList.add('in'));
    return;
  }
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  els.forEach(e => io.observe(e));
}

/* ============================================================
   HEADER — sticky + mega menu
   ============================================================ */
function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  // Sticky
  const onScroll = () => header.classList.toggle('stuck', window.scrollY > 60);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Mega menu
  const navItems = header.querySelectorAll('[data-mega]');
  const megaPanel = header.querySelector('.mega-panel');
  let activeIndex = null;

  function openMega(idx) {
    if (!megaPanel) return;
    activeIndex = idx;
    navItems.forEach((n, i) => n.classList.toggle('active', i === idx));
    megaPanel.classList.add('open');
    header.classList.add('menu-open');
    // swap content
    const contents = megaPanel.querySelectorAll('[data-mega-content]');
    contents.forEach((c, i) => c.hidden = i !== idx);
  }
  function closeMega() {
    if (!megaPanel) return;
    activeIndex = null;
    navItems.forEach(n => n.classList.remove('active'));
    megaPanel.classList.remove('open');
    header.classList.remove('menu-open');
  }

  navItems.forEach((n, i) => {
    n.addEventListener('mouseenter', () => openMega(i));
  });
  header.addEventListener('mouseleave', closeMega);
  megaPanel && megaPanel.addEventListener('mouseleave', closeMega);
}

/* ============================================================
   MOBILE MENU
   ============================================================ */
function initMobileMenu() {
  const menu = document.querySelector('.mobile-menu');
  const openBtn = document.querySelector('.menu-btn');
  const closeBtn = menu && menu.querySelector('.mmenu-close');
  if (!menu || !openBtn) return;

  const open = () => { menu.classList.add('open'); document.body.style.overflow = 'hidden'; };
  const close = () => { menu.classList.remove('open'); document.body.style.overflow = ''; };

  openBtn.addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', close);
  menu.addEventListener('click', e => { if (e.target === menu) close(); });

  // accordion
  menu.querySelectorAll('.mmenu-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = btn.nextElementSibling;
      const open = sub.style.display !== 'none' && sub.offsetHeight > 0;
      menu.querySelectorAll('.mmenu-sub').forEach(s => s.style.display = 'none');
      sub.style.display = open ? 'none' : 'block';
    });
  });
}

/* ============================================================
   SEARCH OVERLAY
   ============================================================ */
function initSearch() {
  const overlay = document.querySelector('.search-overlay');
  const input = overlay && overlay.querySelector('.search-input');
  const openBtns = document.querySelectorAll('[data-open-search]');
  const closeBtn = overlay && overlay.querySelector('[data-close-search]');
  if (!overlay) return;

  const open = () => { overlay.classList.add('open'); input && setTimeout(() => input.focus(), 50); };
  const close = () => { overlay.classList.remove('open'); };

  openBtns.forEach(b => b.addEventListener('click', open));
  closeBtn && closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  // Predictive search
  if (!input) return;
  const popular = overlay.querySelector('.search-popular');
  let timer;

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { renderSearchResults([], ''); return; }
    timer = setTimeout(async () => {
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const data = await res.json();
        renderSearchResults(data.resources.results.products || [], q);
      } catch (e) {
        console.error('Search failed:', e);
        renderSearchResults([], q, true);
      }
    }, 250);
  });

  function renderSearchResults(products, q, isError) {
    const container = overlay.querySelector('.search-results');
    if (!container) return;

    if (!products.length) {
      if (isError) {
        container.innerHTML = '<p style="padding:20px 0;font-size:14px;color:var(--muted);">Something went wrong. Please try again.</p>';
        if (popular) popular.style.display = 'none';
      } else if (q && q.length >= 2) {
        container.innerHTML = `
          <div style="padding:32px 0;text-align:center;">
            <p style="font-size:15px;color:var(--muted);">No results for &ldquo;${escapeHtml(q)}&rdquo;</p>
            <p style="font-size:13px;color:var(--muted-2);margin-top:8px;">Try a different term or <a href="/collections/all" style="color:var(--gold-deep);font-weight:600;text-decoration:underline;">browse all products</a>.</p>
          </div>`;
        if (popular) popular.style.display = 'none';
      } else {
        container.innerHTML = '';
        if (popular) popular.style.display = '';
      }
      return;
    }

    if (popular) popular.style.display = 'none';
    container.innerHTML = products.map(p => `
      <a href="${encodeURI(p.url)}" class="search-result-item" style="display:flex;align-items:center;gap:16px;padding:10px 0;border-bottom:1px solid var(--line);">
        <img src="${escapeHtml(p.image || '')}" alt="${escapeHtml(p.title)}" style="width:46px;height:56px;object-fit:cover;border-radius:3px;flex:0 0 auto;background:var(--beige);" />
        <div style="flex:1;">
          <div style="font-weight:600;font-size:15px;">${escapeHtml(p.title)}</div>
          <div style="font-size:12px;color:var(--muted-2);">${escapeHtml(p.type || '')}</div>
        </div>
        <div style="font-weight:600;">${inr(p.price)}</div>
      </a>
    `).join('');
  }
}

/* ============================================================
   HERO CAROUSEL
   ============================================================ */
function initHeroCarousel() {
  const carousel = document.querySelector('.hero-carousel');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('.hero-slide');
  const dots = carousel.querySelectorAll('.hero-dot');
  const prev = carousel.querySelector('.hero-arrow--prev');
  const next = carousel.querySelector('.hero-arrow--next');
  let current = 0;
  let timer;
  let paused = false;

  function go(n) {
    slides[current].classList.remove('active');
    dots[current] && dots[current].classList.remove('active');
    current = (n + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current] && dots[current].classList.add('active');
  }

  function startTimer() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    timer = setInterval(() => { if (!paused) go(current + 1); }, reduce ? 9000 : 6000);
  }

  if (slides.length > 1) {
    prev && prev.addEventListener('click', () => go(current - 1));
    next && next.addEventListener('click', () => go(current + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    carousel.addEventListener('mouseenter', () => paused = true);
    carousel.addEventListener('mouseleave', () => paused = false);
    startTimer();
  }
}

/* ============================================================
   COUNTDOWN TIMER
   ============================================================ */
function initCountdown(el, targetMs) {
  if (!el) return;
  function update() {
    const left = Math.max(0, targetMs - Date.now());
    const s = Math.floor(left / 1000);
    const h = String(Math.floor(s / 3600)).padStart(2, '0');
    const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
    const sec = String(s % 60).padStart(2, '0');
    const [he, me, se] = el.querySelectorAll('[data-cd-val]');
    if (he) he.textContent = h;
    if (me) me.textContent = m;
    if (se) se.textContent = sec;
    if (left > 0) setTimeout(update, 1000);
  }
  update();
}

function initAllCountdowns() {
  document.querySelectorAll('[data-countdown]').forEach(el => {
    const hours = parseInt(el.dataset.countdown) || 8;
    initCountdown(el, Date.now() + hours * 3600 * 1000);
  });
}

/* ============================================================
   FLASH SALE STOCK BAR
   ============================================================ */
function initFlashProgress() {
  const bar = document.querySelector('.flash-progress-bar');
  if (!bar) return;
  let pct = 68;
  const update = () => { bar.style.width = pct + '%'; };
  update();
  setInterval(() => {
    if (Math.random() < 0.4) { pct = Math.min(94, pct + 1); update(); }
  }, 4000);
  const label = bar.closest('.flash-product-panel')?.querySelector('.flash-sold-label');
  if (label) setInterval(() => { label.textContent = pct + '% claimed — hurry, limited stock'; }, 4000);
}

/* ============================================================
   FAQ ACCORDIONS
   ============================================================ */
function initFaq() {
  document.querySelectorAll('.faq-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const answer = btn.nextElementSibling;
      const open = btn.getAttribute('aria-expanded') === 'true';
      // close all in same group
      const group = btn.closest('[data-faq-group]') || document;
      group.querySelectorAll('.faq-toggle').forEach(b => {
        b.setAttribute('aria-expanded', 'false');
        const a = b.nextElementSibling;
        if (a) a.classList.remove('open');
      });
      if (!open) {
        btn.setAttribute('aria-expanded', 'true');
        answer && answer.classList.add('open');
      }
    });
  });
}

/* ============================================================
   PDP ACCORDIONS
   ============================================================ */
function initPdpAccordions() {
  document.querySelectorAll('.pdp-acc-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const body = btn.nextElementSibling;
      if (!body) return;
      const open = body.classList.contains('open');
      body.classList.toggle('open', !open);
      btn.setAttribute('aria-expanded', String(!open));
    });
  });
}

/* ============================================================
   PDP — SIZE / COLOUR / QTY / STICKY BAR
   ============================================================ */
function initProductPage() {
  const form = document.querySelector('#product-form');
  if (!form) return;

  // Size buttons
  form.querySelectorAll('[data-size-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      form.querySelectorAll('[data-size-btn]').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const input = form.querySelector('[name="id"]');
      if (input && btn.dataset.variantId) input.value = btn.dataset.variantId;
    });
  });

  // Colour swatches
  form.querySelectorAll('[data-color-swatch]').forEach(btn => {
    btn.addEventListener('click', () => {
      form.querySelectorAll('[data-color-swatch]').forEach(b => b.style.boxShadow = 'inset 0 0 0 2px #fff');
      btn.style.boxShadow = '0 0 0 2px var(--ivory), 0 0 0 4px var(--black)';
      const label = form.querySelector('[data-color-label]');
      if (label) label.textContent = btn.dataset.colorName || '';
    });
  });

  // Qty — with live stock validation on increase
  const qtyDisplay = form.querySelector('[data-qty], [data-pdp-qty-val]');
  const qtyWrap = form.querySelector('.pdp-qty-wrap');

  form.querySelectorAll('[data-qty-change], [data-pdp-qty]').forEach(btn => {
    btn.addEventListener('click', async () => {
      if (!qtyDisplay || qtyWrap?.classList.contains('is-checking')) return;
      const current = parseInt(qtyDisplay.textContent, 10) || 1;
      const delta = parseInt(btn.dataset.qtyChange || btn.dataset.pdpQty, 10) || 0;
      const next = Math.max(1, current + delta);
      if (delta < 0) {
        // Decrease never needs a stock check
        qtyDisplay.textContent = next;
        const inp = form.querySelector('[name="quantity"]');
        if (inp) inp.value = next;
        return;
      }
      // Increase: check stock against Shopify before accepting
      qtyWrap?.classList.add('is-checking');
      try {
        const variantId = form.querySelector('[name="id"], [data-pdp-variant-id]')?.value;
        const handle = location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
        const stock = handle && variantId ? await fetchLiveStock(handle, variantId) : Infinity;
        const cartQty = window.Cart?.lastCart?.items?.find(i => String(i.variant_id) === String(variantId))?.quantity || 0;
        const remaining = stock === Infinity ? Infinity : Math.max(0, stock - cartQty);
        if (remaining !== Infinity && next > remaining) {
          const msg = remaining <= 0
            ? (cartQty > 0 ? `Max reached — ${cartQty} already in your cart.` : 'Currently out of stock.')
            : `Only ${remaining} more can be added${cartQty > 0 ? ` (${cartQty} in your cart)` : ''}.`;
          showToast(msg);
        } else {
          qtyDisplay.textContent = next;
          const inp = form.querySelector('[name="quantity"]');
          if (inp) inp.value = next;
        }
      } catch (_) {
        // Network error — fail open so the button still works
        qtyDisplay.textContent = next;
        const inp = form.querySelector('[name="quantity"]');
        if (inp) inp.value = next;
      } finally {
        qtyWrap?.classList.remove('is-checking');
      }
    });
  });

  // Sticky bar
  const stickyBar = document.querySelector('.pdp-sticky');
  const actions = document.querySelector('#pdp-actions');
  if (stickyBar && actions) {
    const io = new IntersectionObserver(([e]) => {
      stickyBar.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(actions);
  }

  // Gallery thumbs
  const thumbs = document.querySelectorAll('.pdp-thumb');
  const mainImg = document.querySelector('.pdp-main-img img');
  thumbs.forEach(t => {
    t.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      if (mainImg) mainImg.src = t.dataset.imgSrc || mainImg.src;
    });
  });
}

/* ============================================================
   PLP — FILTER CHIPS + SORT
   ============================================================ */
function initCollectionPage() {
  const chips = document.querySelectorAll('.plp-chip');
  const sort = document.querySelector('.plp-sort');
  if (!chips.length) return;

  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      chips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
      const cat = chip.dataset.cat || 'all';
      filterProducts(cat, sort ? sort.value : 'featured');
    });
  });

  sort && sort.addEventListener('change', () => {
    const activeCat = document.querySelector('.plp-chip.active')?.dataset.cat || 'all';
    filterProducts(activeCat, sort.value);
  });

  function filterProducts(cat, sortKey) {
    const cards = document.querySelectorAll('[data-product-card]');
    const label = document.querySelector('[data-filter-label]');
    if (label) label.textContent = cat === 'all' ? 'All Products' : cat;

    let visible = Array.from(cards);
    if (cat !== 'all') {
      visible = visible.filter(c => (c.dataset.cat || '').toLowerCase() === cat.toLowerCase());
    }

    // Sort
    const grid = document.querySelector('.prod-grid');
    if (grid) {
      const sorted = visible.sort((a, b) => {
        const ap = parseInt(a.dataset.price) || 0, bp = parseInt(b.dataset.price) || 0;
        const ar = parseFloat(a.dataset.rating) || 0, br = parseFloat(b.dataset.rating) || 0;
        const an = a.dataset.badge === 'new', bn = b.dataset.badge === 'new';
        if (sortKey === 'price-asc') return ap - bp;
        if (sortKey === 'price-desc') return bp - ap;
        if (sortKey === 'rating') return br - ar;
        if (sortKey === 'new') return bn - an;
        return (b.dataset.badge === 'bestseller' ? 1 : 0) - (a.dataset.badge === 'bestseller' ? 1 : 0);
      });
      cards.forEach(c => c.style.display = 'none');
      sorted.forEach(c => { c.style.display = ''; grid.appendChild(c); });
    }
  }
}

/* ============================================================
   CART DRAWER — Shopify AJAX Cart API
   ============================================================ */
const Cart = {
  overlay: null,
  drawer: null,
  countEls: [],
  lastCart: null,

  init() {
    this.overlay = document.querySelector('.cart-overlay');
    this.drawer = document.querySelector('.cart-drawer');
    this.countEls = document.querySelectorAll('[data-cart-count]');

    document.querySelectorAll('[data-open-cart]').forEach(b => b.addEventListener('click', () => this.open()));
    this.overlay && this.overlay.addEventListener('click', () => this.close());
    const closeBtn = this.drawer && this.drawer.querySelector('[data-close-cart]');
    closeBtn && closeBtn.addEventListener('click', () => this.close());

    this.fetchAndRender();

    // qty controls
    document.addEventListener('click', e => {
      if (e.target.closest('[data-cart-qty]')) {
        const btn = e.target.closest('[data-cart-qty]');
        const ctrl = btn.closest('.cart-qty-ctrl');
        if (ctrl && ctrl.classList.contains('is-updating')) return;
        const key = btn.dataset.key;
        const delta = parseInt(btn.dataset.cartQty);
        const display = ctrl?.querySelector('[data-qty-val]');
        const current = parseInt(display?.textContent || 1);
        const newQty = Math.max(0, current + delta);
        this.setQtyLoading(ctrl, true);
        if (delta > 0) {
          this.checkStockAndUpdate(ctrl, key, newQty, current);
        } else {
          this.updateQty(key, newQty);
        }
      }
      if (e.target.closest('[data-remove-item]')) {
        const removeBtn = e.target.closest('[data-remove-item]');
        const key = removeBtn.dataset.key;
        const cartItem = removeBtn.closest('.cart-item');
        if (cartItem) {
          cartItem.classList.add('is-removing');
          const h = cartItem.offsetHeight;
          cartItem.style.transition = 'none';
          cartItem.style.maxHeight = h + 'px';
          cartItem.offsetHeight; // reflow
          cartItem.style.transition = 'opacity .22s ease, transform .22s ease, max-height .3s ease .05s, padding-top .3s ease .05s, padding-bottom .3s ease .05s';
          cartItem.style.opacity = '0';
          cartItem.style.transform = 'translateX(8px)';
          cartItem.style.maxHeight = '0';
          cartItem.style.paddingTop = '0';
          cartItem.style.paddingBottom = '0';
        }
        this.updateQty(key, 0);
      }
    });

    // Clear cart
    const clearBtn = this.drawer && this.drawer.querySelector('[data-clear-cart]');
    const clearModal = document.getElementById('cart-clear-modal');
    const clearCancel = document.getElementById('cart-clear-cancel');
    const clearConfirm = document.getElementById('cart-clear-confirm');
    const clearBackdrop = document.getElementById('cart-clear-backdrop');

    if (clearBtn && clearModal) {
      const openClearModal = () => clearModal.classList.add('open');
      const closeClearModal = () => clearModal.classList.remove('open');

      clearBtn.addEventListener('click', openClearModal);
      clearCancel && clearCancel.addEventListener('click', closeClearModal);
      clearBackdrop && clearBackdrop.addEventListener('click', closeClearModal);
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && clearModal.classList.contains('open')) closeClearModal();
      });

      clearConfirm && clearConfirm.addEventListener('click', async () => {
        clearConfirm.disabled = true;
        clearConfirm.textContent = 'Clearing…';
        await fetch('/cart/clear.js', { method: 'POST' });
        closeClearModal();
        clearConfirm.disabled = false;
        clearConfirm.textContent = 'Clear Cart';
        await this.fetchAndRender();
      });
    }
  },

  setQtyLoading(ctrl, loading) {
    if (!ctrl) return;
    ctrl.classList.toggle('is-updating', loading);
    ctrl.querySelectorAll('button').forEach(b => b.disabled = loading);
  },

  async checkStockAndUpdate(ctrl, key, newQty, currentQty = 0) {
    try {
      const variantId = ctrl?.dataset.variant;
      const handle = ctrl?.dataset.handle;
      if (variantId && handle) {
        invalidateStockCache(handle); // always fetch live — no cache on qty checks
        const stock = await fetchLiveStock(handle, variantId);
        // newQty is the ABSOLUTE new count for just this one line — a discount app
        // can hold more of the variant in other cart lines, so what this line can
        // grow to is capped by stock minus what those OTHER lines already hold,
        // not by the variant's cart-wide total (which would double-count this line).
        const otherLinesQty = Math.max(0, cartQtyForVariant(this.lastCart?.items, variantId) - currentQty);
        const remaining = stock === Infinity ? Infinity : Math.max(0, stock - otherLinesQty);
        if (newQty > remaining) {
          this.setQtyLoading(ctrl, false);
          const msg = remaining <= 0
            ? (otherLinesQty > 0 ? `Max reached — ${otherLinesQty} already in your cart.` : 'Currently out of stock.')
            : `Only ${remaining} more can be added${otherLinesQty > 0 ? ` (${otherLinesQty} in your cart)` : ''}.`;
          showToast(msg);
          return;
        }
      }
    } catch (_) {}
    this.updateQty(key, newQty);
  },

  open() {
    this.overlay && this.overlay.classList.add('open');
    this.drawer && this.drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.fetchAndRender();
  },

  close() {
    this.overlay && this.overlay.classList.remove('open');
    this.drawer && this.drawer.classList.remove('open');
    document.body.style.overflow = '';
  },

  async fetchAndRender() {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await res.json();
      this.render(cart);
      return cart;
    } catch (e) { return null; }
  },

  async addItem(variantId, qty = 1, { handle, properties = {} } = {}) {
    // Track existing cart qty so we can detect Shopify's silent cap after the add
    let existingQty = 0;

    // ATC-time guard: force-fresh stock + current cart state compared together
    // so that (cart_existing + qty_being_added) never exceeds known available stock.
    // When fetchLiveStock returns Infinity (inventory not tracked or storefront
    // API data lag), we skip the client check and rely on Shopify server enforcement.
    if (handle) {
      try {
        invalidateStockCache(handle);
        const [cartData, stock] = await Promise.all([
          fetch('/cart.js', { cache: 'no-store' }).then(r => r.json()).catch(() => ({ items: [] })),
          fetchLiveStock(handle, variantId)
        ]);
        existingQty = cartQtyForVariant(cartData.items, variantId);
        if (stock !== Infinity) {
          const remaining = stock - existingQty;
          if (qty > remaining) {
            if (remaining <= 0) {
              showToast(existingQty > 0
                ? `Max quantity reached — you already have ${existingQty} in your cart.`
                : 'Currently out of stock.');
            } else {
              showToast(`Only ${remaining} more item${remaining !== 1 ? 's' : ''} can be added (${existingQty} already in your cart, ${stock} total available).`);
            }
            return false;
          }
        }
      } catch (_) {} // network error — fail open, server will enforce
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty, properties })
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.description || errData.message || 'Could not add item. Please try again.');
      }
      const item = await res.json();
      if (handle) invalidateStockCache(handle);
      const freshCart = await this.fetchAndRender();
      this.open();

      // Detect Shopify's silent quantity cap by re-reading the CART-WIDE total for
      // this variant from a fresh cart fetch — item.quantity is only the ONE line
      // this request touched, and a discount app can split a variant across
      // several lines, so it's never safe to treat as "the total now in cart".
      // We never cache this number (Dawn's theme doesn't either) — always recheck
      // fresh so a one-off miscount here can't poison later checks.
      const actualTotal = freshCart ? cartQtyForVariant(freshCart.items, variantId) : item.quantity;
      const expectedTotal = existingQty + qty;
      if (actualTotal < expectedTotal) {
        const actuallyAdded = Math.max(0, actualTotal - existingQty);
        if (actuallyAdded > 0) {
          showToast(`Added ${actuallyAdded} to cart — stock limit reached (${actualTotal} total in your cart).`);
        } else {
          showToast(`Stock limit reached — your cart already has the maximum available (${actualTotal}).`);
        }
      } else {
        showToast(`Added to cart · ${item.product_title}`);
      }
      return true;
    } catch (e) {
      showToast(e.message || 'Could not add item. Please try again.');
      return false;
    }
  },

  async updateQty(key, requestedQty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: requestedQty })
      });
      const cart = await res.json();
      // If Shopify capped the quantity (insufficient stock), tell the user
      if (requestedQty > 0) {
        const item = cart.items?.find(i => i.key === key);
        if (item && item.quantity < requestedQty) {
          // item.quantity is just THIS line's count — a discount app can split the
          // variant across several lines, so the true available number is the
          // cart-wide total. Report it fresh; never cache it (see addItem).
          const actualTotal = cartQtyForVariant(cart.items, item.variant_id);
          showToast(`Out of stock. Only ${actualTotal} item${actualTotal !== 1 ? 's' : ''} currently available.`);
          this.render(cart);
          return { cart, capped: true };
        }
      }
      this.render(cart);
      return { cart, capped: false };
    } catch (e) {
      await this.fetchAndRender();
      return { cart: null, capped: false };
    }
  },

  render(cart) {
    this.lastCart = cart;

    // Show/hide the "Clear all" button based on whether cart has items
    const clearBtn = this.drawer && this.drawer.querySelector('[data-clear-cart]');
    if (clearBtn) clearBtn.style.display = cart.items.length ? 'inline' : 'none';

    const FREE_SHIP_AT = 299900; // ₹2,999 in paise
    const total = cart.total_price;
    const itemsSubtotal = cart.items_subtotal_price;
    const remaining = Math.max(0, FREE_SHIP_AT - total);
    const pct = Math.min(100, (total / FREE_SHIP_AT) * 100);

    // Update counts
    this.countEls.forEach(el => el.textContent = cart.item_count);

    const shipBar = this.drawer && this.drawer.querySelector('.cart-ship-bar');
    if (shipBar) {
      shipBar.querySelector('[data-ship-msg]').innerHTML = remaining > 0
        ? `Add <b>${inr(remaining / 100)}</b> more for <b>FREE shipping</b>`
        : `<span style="color:#1F6E4E;font-weight:600;">🎉 You've unlocked free shipping!</span>`;
      const fill = shipBar.querySelector('.cart-ship-fill');
      if (fill) fill.style.width = pct + '%';
    }

    const items = this.drawer && this.drawer.querySelector('.cart-items');
    if (!items) return;

    if (!cart.items.length) {
      items.innerHTML = `
        <div style="text-align:center;padding:60px 20px;color:var(--muted-2);">
          <div style="display:flex;justify-content:center;margin-bottom:16px;">${icon(IF_ICONS.bag, 42, 1, 'none')}</div>
          <div style="font-family:var(--serif);font-size:20px;color:var(--black);">Your cart is empty</div>
          <p style="font-size:13.5px;margin-top:8px;">Explore the collection and add your favourites.</p>
          <button onclick="Cart.close()" class="btn btn-dark btn-sm" style="margin-top:18px;">Continue Shopping</button>
        </div>`;
    } else {
      items.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <div class="cart-item-img">
            <img src="${item.image}" alt="${item.title}" loading="lazy" />
          </div>
          <div style="flex:1;display:flex;flex-direction:column;">
            <div style="display:flex;justify-content:space-between;gap:8px;">
              <div style="font-family:var(--serif);font-size:15px;line-height:1.2;">${item.product_title}</div>
              <button data-remove-item data-key="${item.key}" aria-label="Remove" style="color:var(--muted);">${icon(IF_ICONS.x, 15)}</button>
            </div>
            <div style="font-size:11.5px;color:var(--muted-2);margin-top:2px;">${item.variant_title !== 'Default Title' ? 'Size: ' + item.variant_title : ''}</div>
            <div style="display:flex;justify-content:space-between;align-items:center;margin-top:auto;">
              <div class="cart-qty-ctrl" data-key="${item.key}" data-variant="${item.variant_id}" data-handle="${item.handle}">
                <button class="cart-qty-btn" data-cart-qty="-1" data-key="${item.key}">${icon(IF_ICONS.minus, 13, 2)}</button>
                <span class="cart-qty-num" data-qty-val>${item.quantity}</span>
                <button class="cart-qty-btn" data-cart-qty="1" data-key="${item.key}">${icon(IF_ICONS.plus, 13, 2)}</button>
              </div>
              <div style="font-weight:700;">${inr(item.final_line_price / 100)}</div>
            </div>
          </div>
        </div>
      `).join('');
    }

    const footer = this.drawer && this.drawer.querySelector('.cart-footer');
    if (footer) {
      footer.style.display = cart.items.length ? '' : 'none';
      const sub = footer.querySelector('[data-subtotal]');
      if (sub) sub.textContent = inr(itemsSubtotal / 100);
      // Render coupon section (auto pills + code applied / input)
      const couponSection = footer.querySelector('[data-coupon-section]');
      if (couponSection) renderCouponSection(cart, couponSection);

      // Savings line below subtotal
      const discounts = footer.querySelector('[data-discounts]');
      if (discounts) {
        const td = cart.total_discount || 0;
        discounts.innerHTML = td > 0
          ? `<div style="display:flex;justify-content:space-between;margin-bottom:4px;font-size:13px;color:#1a7a4a;font-weight:600;"><span>You save</span><span>-${inr(td/100)}</span></div>`
          : '';
      }
      const checkoutBtn = footer.querySelector('[data-checkout]');
      if (checkoutBtn) checkoutBtn.textContent = `Checkout · ${inr(total / 100)}`;
    }
  }
};

/* ============================================================
   PRODUCT FORM SUBMIT (add to cart)
   ============================================================ */
function initProductForms() {
  document.querySelectorAll('[data-atc-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
      if (!variantId) return;
      await Cart.addItem(variantId, qty);
    });
  });

  // Quick add buttons (product cards)
  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.quickAdd;
      await Cart.addItem(variantId, 1);
    });
  });
}

/* ============================================================
   TOAST
   ============================================================ */
function showToast(msg) {
  let toast = document.querySelector('.action-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'action-toast';
    toast.innerHTML = icon(IF_ICONS.check, 16, 2.2, 'none') + '<span></span>';
    toast.style.color = 'var(--ivory)';
    document.body.appendChild(toast);
  }
  toast.querySelector('span').textContent = msg;
  toast.classList.add('show');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove('show'), 2600);
}

/* ============================================================
   EXIT INTENT
   ============================================================ */
function initExitIntent() {
  const overlay = document.querySelector('.exit-overlay');
  if (!overlay || sessionStorage.getItem('if_exit')) return;
  const close = () => { overlay.classList.remove('open'); };
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
  overlay.querySelectorAll('[data-close-exit]').forEach(b => b.addEventListener('click', close));

  const onLeave = e => {
    if (e.clientY <= 0) {
      overlay.classList.add('open');
      sessionStorage.setItem('if_exit', '1');
      document.removeEventListener('mouseout', onLeave);
    }
  };
  setTimeout(() => document.addEventListener('mouseout', onLeave), 6000);
}


/* ============================================================
   QUICK VIEW
   ============================================================ */
function initQuickView() {
  const overlay = document.querySelector('.qv-overlay');
  if (!overlay) return;

  const close = () => overlay.classList.remove('open');
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
  overlay.querySelectorAll('[data-close-qv]').forEach(b => b.addEventListener('click', close));

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    const handle = btn.dataset.quickView;
    if (!handle) return;

    try {
      const res = await fetch(`/products/${handle}.js`, { cache: 'no-store' });
      const p = await res.json();

      // Pre-populate inventory from data-variants-inventory if available
      if (btn.dataset.variantsInventory) {
        try {
          const inv = JSON.parse(btn.dataset.variantsInventory);
          inv.forEach(item => {
            setKnownStock(handle, String(item.id), item.inventory_quantity, item.inventory_management, item.inventory_policy);
          });
        } catch (_) {}
      }

      renderQV(p);
      overlay.classList.add('open');
    } catch (err) {}
  });

  function renderQV(p) {
    const modal = overlay.querySelector('.qv-modal');
    if (!modal) return;

    // Color name → CSS value map for swatch rendering
    const COLOR_MAP = {
      white:'#FFFFFF', ivory:'#FFFFF0', cream:'#FFFDD0', 'off-white':'#FAF9F6',
      black:'#111111', charcoal:'#374151',
      grey:'#9CA3AF', gray:'#9CA3AF', silver:'#C0C0C0',
      beige:'#E8DCC8', tan:'#D2B48C', khaki:'#C3B091', camel:'#C19A6B', sand:'#C2B280',
      brown:'#7B4F2E', chocolate:'#5C3317',
      navy:'#0C2533', 'navy blue':'#0C2533',
      blue:'#1B4FD8', 'royal blue':'#4169E1', 'sky blue':'#87CEEB', 'light blue':'#ADD8E6', 'dark blue':'#00008B',
      red:'#D83030', maroon:'#800000', burgundy:'#800020', wine:'#722F37',
      orange:'#E86520', rust:'#B7410E', terracotta:'#C24410',
      yellow:'#F0C040', mustard:'#DFAD00', gold:'#FFD700',
      green:'#2D7D46', olive:'#6B7B3A', 'dark green':'#006400', 'forest green':'#228B22',
      pink:'#F48FB1', rose:'#FF007F', coral:'#FF6B6B', peach:'#FFCBA4',
      purple:'#7C3AED', lavender:'#E6E6FA', violet:'#8B00FF',
    };

    const realOptions = (p.options || []).filter(o =>
      !(o.name === 'Title' && o.values.length === 1 && o.values[0] === 'Default Title')
    );

    let activeVariant = p.variants.find(v => {
      if (v.available) return true;
      const k = _knownStock[p.handle]?.[String(v.id)];
      return k?.management && k.qty > 0;
    }) || p.variants[0] || {};

    const selectedOpts = {};
    realOptions.forEach((opt, i) => {
      selectedOpts[opt.name] = activeVariant[`option${i + 1}`] || opt.values[0];
    });

    function matchVariant() {
      return p.variants.find(v =>
        realOptions.every((opt, i) => v[`option${i + 1}`] === selectedOpts[opt.name])
      ) || p.variants[0] || {};
    }

    // Check availability for a value, filtered by all OTHER currently selected options
    function isAvail(optIdx, val) {
      return p.variants.some(v => {
        if (v[`option${optIdx + 1}`] !== val) return false;
        const k = _knownStock[p.handle]?.[String(v.id)];
        const effAvail = v.available || (k?.management && k.qty > 0);
        if (!effAvail) return false;
        return realOptions.every((o, j) => j === optIdx || v[`option${j + 1}`] === selectedOpts[o.name]);
      });
    }

    function optionGroupsHTML() {
      if (!realOptions.length) return '';
      return realOptions.map((opt, i) => {
        const isColor = /colou?r/i.test(opt.name);
        const btns = opt.values.map(val => {
          const active = selectedOpts[opt.name] === val;
          const avail = isAvail(i, val);
          if (isColor) {
            const css = COLOR_MAP[val.toLowerCase()] || '#aaa';
            return `<button type="button" class="qv-color-swatch${active ? ' active' : ''}${!avail ? ' is-oos' : ''}"
              style="background:${css};" title="${val}"
              data-opt-name="${opt.name}" data-opt-val="${val}"
              aria-label="${val}${avail ? '' : ' (out of stock)'}" aria-pressed="${active}"></button>`;
          }
          return `<button type="button" class="size-btn${active ? ' active' : ''}${!avail ? ' is-oos' : ''}"
            data-opt-name="${opt.name}" data-opt-val="${val}">${val}</button>`;
        }).join('');
        return `
          <div style="margin-top:18px;">
            <div style="font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--muted-2);margin-bottom:10px;font-weight:700;">${isColor ? opt.name : 'Select '+opt.name}</div>
            <div style="display:flex;gap:${isColor ? '10' : '8'}px;flex-wrap:wrap;">${btns}</div>
          </div>`;
      }).join('');
    }

    const productType = p.product_type && p.product_type !== 'undefined' ? p.product_type : '';

    function qvPriceRowHTML(variant) {
      const vPrice = variant.price || 0;
      const vMrp = variant.compare_at_price || 0;
      const vPct = vMrp > vPrice ? Math.floor((vMrp - vPrice) / vMrp * 100) : 0;
      return `<span style="font-family:var(--serif);font-size:30px;font-weight:600;">${inr(vPrice / 100)}</span>` +
        (vMrp > vPrice ? `<span style="text-decoration:line-through;color:var(--muted);font-size:16px;">${inr(vMrp / 100)}</span><span class="badge badge-gold">−${vPct}%</span>` : '');
    }

    // Show image for the active variant if available, otherwise first product image
    const variantImg = activeVariant.featured_image?.src || p.images[0] || '';

    modal.innerHTML = `
      <div class="qv-img"><img src="${variantImg}" alt="${p.title}" /></div>
      <div class="qv-body">
        <div style="display:flex;justify-content:space-between;align-items:flex-start;">
          ${productType ? `<div class="eyebrow">${productType}</div>` : '<div></div>'}
          <button type="button" data-close-qv aria-label="Close">${icon(IF_ICONS.x, 20)}</button>
        </div>
        <h3 style="font-size:26px;margin-top:8px;line-height:1.2;">${p.title}</h3>
        <div data-qv-price-row style="display:flex;align-items:baseline;gap:12px;margin:12px 0 0;">${qvPriceRowHTML(activeVariant)}</div>
        <div data-qv-options>${optionGroupsHTML()}</div>
        <div data-qv-stock></div>
        <a href="/products/${p.handle}" class="btn btn-dark btn-block" style="margin-top:22px;display:flex;align-items:center;justify-content:center;gap:7px;">View Full Details ${icon(IF_ICONS.arrowR, 14, 1.8)}</a>
        <div style="display:flex;gap:16px;margin-top:18px;font-size:11.5px;color:var(--muted-2);justify-content:center;">
          <span style="display:inline-flex;gap:6px;align-items:center;">${icon(IF_ICONS.truck,14,1.5)} Free shipping</span>
          <span style="display:inline-flex;gap:6px;align-items:center;">${icon(IF_ICONS.shield,14,1.5)} Secure payment</span>
          <span style="display:inline-flex;gap:6px;align-items:center;">${icon(IF_ICONS.refresh,14,1.5)} Easy returns</span>
        </div>
      </div>`;

    // Informational stock line only — no Add to Cart / Buy Now actions in quick view.
    function renderQVStock(variant) {
      const stockEl = modal.querySelector('[data-qv-stock]');
      if (!stockEl) return;
      const known = _knownStock[p.handle]?.[String(variant.id)];
      const inStock = variant?.available !== false || (known?.management && known.qty > 0);
      const maxQty = (known && known.management) ? Math.max(known.qty, 0) : Infinity;
      if (inStock) {
        stockEl.innerHTML = (maxQty > 0 && maxQty < 10)
          ? `<div style="font-size:12px;color:var(--gold-deep);margin-top:16px;">Only ${maxQty} left in stock</div>`
          : '';
      } else {
        stockEl.innerHTML = `<div style="font-size:12px;color:var(--muted);margin-top:16px;">Currently out of stock</div>`;
      }
    }

    function attachOptHandlers() {
      modal.querySelectorAll('[data-opt-name]').forEach(btn => {
        btn.addEventListener('click', () => {
          selectedOpts[btn.dataset.optName] = btn.dataset.optVal;
          activeVariant = matchVariant();
          // Re-render options so cross-option OOS state updates
          const optsEl = modal.querySelector('[data-qv-options]');
          if (optsEl) optsEl.innerHTML = optionGroupsHTML();
          // Update price row with new variant's price and discount
          const priceRowEl = modal.querySelector('[data-qv-price-row]');
          if (priceRowEl) priceRowEl.innerHTML = qvPriceRowHTML(activeVariant);
          // Also swap image to the variant's image if it has one
          const newImg = activeVariant.featured_image?.src;
          if (newImg) modal.querySelector('.qv-img img').src = newImg;
          attachOptHandlers();
          renderQVStock(activeVariant);
        });
      });
    }

    modal.querySelector('[data-close-qv]')?.addEventListener('click', close);
    attachOptHandlers();
    renderQVStock(activeVariant);
  }
}

/* ============================================================
   BOTTOM NAV
   ============================================================ */
function initBottomNav() {
  const nav = document.querySelector('.bottom-nav');
  if (!nav) return;

  nav.querySelectorAll('[data-bottom-action]').forEach(a => {
    a.addEventListener('click', e => {
      const action = a.dataset.bottomAction;
      if (action === 'cart') { e.preventDefault(); Cart.open(); }
      if (action === 'search') { e.preventDefault(); document.querySelector('.search-overlay')?.classList.add('open'); }
    });
  });
}

/* ============================================================
   NEWSLETTER
   ============================================================ */
function initNewsletter() {
  const forms = document.querySelectorAll('[data-newsletter-form]');
  forms.forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const email = input?.value.trim();
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        const err = form.querySelector('[data-newsletter-error]');
        if (err) err.textContent = 'Please enter a valid email address.';
        return;
      }
      const done = form.querySelector('[data-newsletter-done]');
      if (done) { done.style.display = 'block'; form.style.display = 'none'; }
      showToast('Welcome to the club — check your inbox!');
    });
  });
}

function initNameFields() {
  document.querySelectorAll('[data-name-field]').forEach(input => {
    input.addEventListener('input', () => {
      const cleaned = input.value.replace(/[^A-Za-z\s'.-]/g, '');
      if (cleaned !== input.value) input.value = cleaned;
    });
  });
}

/* ============================================================
   INIT
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initHeader();
  initMobileMenu();
  initSearch();
  initHeroCarousel();
  initAllCountdowns();
  initFlashProgress();
  initFaq();
  initFaqItems();
  initPdpAccordions();
  initFBT();
  initSizeGuide();
  initRelatedProducts();
  initProductPage();
  initCollectionPage();
  Cart.init();
  initProductForms();
  initQuickView();
  initExitIntent();
  initBottomNav();
  initNewsletter();
  initNameFields();
});

// When a mobile browser restores this page from the back/forward cache (e.g.
// tapping back after adding to cart), it can skip re-running scripts entirely —
// window.Cart.lastCart stays frozen at whatever it was before, so every stock
// check on this "restored" page thinks the cart is emptier than it really is.
// Forcing a fresh fetch here is what stops the "add 10, go back, add 10 again,
// repeat forever" loop.
window.addEventListener('pageshow', (e) => {
  if (e.persisted) Cart.fetchAndRender();
});

/* ============================================================
   FAQ ITEMS — data-faq attribute pattern (sections-based)
   ============================================================ */
function initFaqItems() {
  document.querySelectorAll('[data-faq]').forEach(item => {
    const btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
      const chevron = btn.querySelector('.faq-chevron');
      if (chevron) chevron.style.transform = isOpen ? '' : 'rotate(-180deg)';
    });
  });
}

/* ============================================================
   FREQUENTLY BOUGHT TOGETHER — add all to cart
   ============================================================ */
function initFBT() {
  const btn = document.querySelector('[data-fbt-add]');
  if (!btn) return;

  btn.addEventListener('click', async () => {
    const ids = (btn.dataset.variants || '').split(',').map(s => s.trim()).filter(Boolean);
    if (!ids.length) return;

    const label = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> Adding…';

    try {
      for (const id of ids) {
        await Cart.addItem(parseInt(id), 1);
      }
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12l5 5L20 6"/></svg> Added to Cart!';
      setTimeout(() => { btn.innerHTML = label; btn.disabled = false; }, 2500);
    } catch {
      btn.innerHTML = label;
      btn.disabled = false;
      showToast('Could not add items — please try again.');
    }
  });
}

/* ============================================================
   SIZE GUIDE MODAL
   ============================================================ */
function initSizeGuide() {
  const overlay = document.querySelector('[data-sg-overlay]');
  if (!overlay) return;

  function open() {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-sg-open]').forEach(btn => btn.addEventListener('click', open));
  overlay.querySelector('[data-sg-close]')?.addEventListener('click', close);
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && overlay.classList.contains('open')) close(); });
}

/* ============================================================
   RELATED PRODUCTS — load-more (PDP)
   ============================================================ */
function initRelatedProducts() {
  const grid = document.querySelector('[data-rp-grid]');
  if (!grid) return;
  const items = Array.from(grid.querySelectorAll('[data-rp-item]'));
  const wrap = document.querySelector('[data-rp-loadmore-wrap]');
  const btn = wrap ? wrap.querySelector('[data-rp-loadmore]') : null;
  if (!items.length) return;

  let shown = 0;

  function getCols() {
    return getComputedStyle(grid).gridTemplateColumns.trim().split(/\s+/).length;
  }

  function reveal(rows) {
    const n = getCols() * rows;
    const end = Math.min(shown + n, items.length);
    for (let i = shown; i < end; i++) items[i].classList.remove('rp-item-hidden');
    shown = end;
    if (wrap && shown >= items.length) wrap.hidden = true;
  }

  items.forEach(el => el.classList.add('rp-item-hidden'));
  reveal(2);
  if (btn) btn.addEventListener('click', () => reveal(2));
}

// Expose for inline usage (accessible to section inline scripts)
/* ── COUPON / DISCOUNT HELPERS ── */

async function applyDiscountAjax(code) {
  try {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ discount: code })
    });
    const cart = await res.json();
    const applied = (cart.discount_codes || []).some(d => d.code.toUpperCase() === code.toUpperCase() && d.applicable === true);
    if (applied) return {success: true, cart};
    return {success: false, error: 'Invalid or expired coupon code. Please try again.'};
  } catch (_) {
    return {success: false, error: 'Something went wrong. Please try again.'};
  }
}

async function removeDiscountAjax() {
  try {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ discount: '' })
    });
    const cart = await res.json();
    return (cart.discount_codes || []).length === 0 ? {success: true, cart} : {success: false};
  } catch (_) {
    return {success: false};
  }
}

function renderCouponSection(cart, container) {
  if (!container) return;
  const apps = cart.discount_applications || [];
  const codes = cart.discount_codes || [];
  const totalDiscount = cart.total_discount || 0;
  const autoApps = apps.filter(a => a.type === 'automatic');
  const codeApps = apps.filter(a => a.type === 'discount_code');
  const hasCode = codeApps.length > 0;

  const tagIcon = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>`;
  const checkIcon = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#15803d" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>`;

  let html = '';

  // Auto-applied offers
  autoApps.forEach(app => {
    const saving = app.total_allocated_amount || 0;
    html += `
      <div class="cq-auto-pill">
        <div class="cq-auto-icon">${tagIcon}</div>
        <div class="cq-auto-text">
          <span class="cq-offer-name">${escapeHtml(app.title)}</span>
          <span class="cq-auto-badge">Auto Applied</span>
        </div>
        ${saving ? `<span class="cq-saving">-${inr(saving/100)}</span>` : ''}
      </div>`;
  });

  // Manual code: applied pill OR input
  if (hasCode) {
    const label = codes.map(c => c.code).join(', ') || codeApps.map(a => a.title).join(', ');
    html += `
      <div class="cq-applied-pill">
        <div class="cq-applied-top">
          ${checkIcon}
          <span class="cq-applied-label">Coupon Applied</span>
        </div>
        <div class="cq-applied-row">
          <span class="cq-code-name">${escapeHtml(label)}</span>
          <span class="cq-saving cq-saving-green">-${inr(totalDiscount/100)}</span>
        </div>
        <button class="cq-remove-btn" data-remove-coupon>✕ Remove Code</button>
      </div>`;
  } else {
    html += `
      <div class="cq-input-wrap" data-coupon-input-wrap>
        <div class="cq-input-row">
          <input type="text" class="cq-input" data-coupon-input placeholder="Enter coupon code" autocomplete="off" autocapitalize="characters" />
          <button class="cq-apply-btn" data-coupon-apply>Apply</button>
        </div>
        <div class="cq-error" data-coupon-error style="display:none;"></div>
      </div>`;
  }

  container.innerHTML = html;

  // Bind remove
  const removeBtn = container.querySelector('[data-remove-coupon]');
  if (removeBtn) {
    removeBtn.addEventListener('click', async () => {
      removeBtn.disabled = true;
      removeBtn.textContent = 'Removing…';
      const result = await removeDiscountAjax();
      if (result.success) {
        Cart.render(result.cart);
      } else {
        removeBtn.disabled = false;
        removeBtn.textContent = '✕ Remove Code';
        showToast('Could not remove coupon. Please try again.');
      }
    });
  }

  // Bind apply
  const applyBtn = container.querySelector('[data-coupon-apply]');
  const input = container.querySelector('[data-coupon-input]');
  const errorEl = container.querySelector('[data-coupon-error]');
  if (applyBtn && input) {
    const showError = msg => { if (errorEl) { errorEl.textContent = msg; errorEl.style.display = msg ? 'block' : 'none'; }};
    const doApply = async () => {
      const code = input.value.trim().toUpperCase();
      if (!code) { showError('Please enter a coupon code.'); return; }
      applyBtn.disabled = true;
      applyBtn.textContent = 'Checking…';
      showError('');
      const result = await applyDiscountAjax(code);
      if (result.success) {
        Cart.render(result.cart);
      } else {
        applyBtn.disabled = false;
        applyBtn.textContent = 'Apply';
        showError(result.error);
      }
    };
    applyBtn.addEventListener('click', doApply);
    input.addEventListener('keydown', e => { if (e.key === 'Enter') doApply(); });
  }
}

function initDiscountInput(container) {
  // Kept for backward compatibility — now delegates to renderCouponSection
  if (!container) return;
  const applyBtn = container.querySelector('[data-coupon-apply]');
  if (applyBtn) return; // already wired by renderCouponSection
}

window.Cart = Cart;
window.showToast = showToast;
window.fetchLiveStock = fetchLiveStock;
window.invalidateStockCache = invalidateStockCache;
window.setKnownStock = setKnownStock;
window.IF = {
  formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
};
